import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { eventLogger } from "../../utils/eventLogger";

interface DownloadFileButtonProps {
  url: string;
  name: string;
}

export const DownloadFileButton: React.FC<DownloadFileButtonProps> = ({
  url,
  name,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = () => {
    setIsLoading(true);
    setTimeout(() => {
      const a = document.createElement("a");
      a.href = url;
      a.download = "";
      document.body.appendChild(a);
      a.click();
      a.remove();
      setIsLoading(false);
      eventLogger.track({ name: "click", action: "download" });
    }, 2000);
  };

  return (
    <Button
      variant="outlined"
      startIcon={isLoading ? <CircularProgress size={20} /> : <DownloadIcon />}
      onClick={handleDownload}
    >
      {name}
    </Button>
  );
};
